import { jsx as _jsx } from "react/jsx-runtime";
export function Button({ variant = "primary", size = "md", fullWidth, className = "", children, ...rest }) {
    const base = "inline-flex items-center justify-center gap-2 font-medium active:opacity-80 transition-opacity disabled:opacity-50 disabled:pointer-events-none";
    const sizeCls = size === "sm"
        ? "px-3 py-1.5 text-xs rounded-lg"
        : size === "lg"
            ? "px-6 py-3 text-sm rounded-xl"
            : "px-5 py-2.5 text-sm rounded-xl";
    const outlinedPad = size === "sm" ? "px-3 py-1.5 text-xs rounded-lg" : "px-4 py-2.5 text-sm rounded-xl";
    const variantCls = variant === "primary"
        ? `bg-[var(--text-primary)] text-white font-semibold ${sizeCls} hover:bg-[var(--interactive-hover)] transition-colors`
        : variant === "outlined"
            ? `border border-[#DDDDDD] bg-[var(--card-bg)] text-[var(--text-primary)] ${outlinedPad} hover:bg-[var(--page-bg)] transition-colors`
            : variant === "ghost"
                ? `${sizeCls} bg-transparent text-[var(--text-secondary)] hover:text-[var(--text-primary)] transition-colors`
                : variant === "destructive"
                    ? `bg-[var(--status-error-bg)] text-[var(--status-error-text)] ${outlinedPad} hover:bg-[#FECACA] transition-colors`
                    : `bg-[var(--green)] text-white font-semibold ${sizeCls} hover:bg-[var(--green-dark)] transition-colors`;
    const w = fullWidth ? "w-full" : "";
    return (_jsx("button", { type: "button", className: `${base} ${variantCls} ${w} ${className}`, ...rest, children: children }));
}
//# sourceMappingURL=Button.js.map